<script>
    import {onMount} from "svelte";
    import {getObjects, saveObj, getObj, deleteObj} from '../lib/data.js';
    import { notifier } from '@beyonk/svelte-notifications'
    import Form from '../Forms/Form.svelte';
    import Loader from '../Utilities/Loader.svelte';

    export let params;

    let users = getObjects("users");
    let currentUser = {};

    $: currentUser = GetUser(params.id);
    let errors = {};

    let fields = [
        {name: "name", placeholder: "User Name", label: "Name", required: true},
        {name: "title", placeholder: "Title", label: "Title"},
        {name: "email", placeholder: "Email", label: "Email", type: "email"},
        {name: "phone", placeholder: "Phone", label: "Phone", type:"tel"},
        {name: "pwd", placeholder: "Password", label: "Password", type: "password"},

    ]

    function SaveUser() {
        saveObj("users", currentUser).then((user) => {
            notifier.send("User Saved", "success")
            currentUser = user;
            currentUser.pwd = "";
            LoadUsers()
        }).catch((error) => {
            errors = error;
        });
    }

    function DeleteUser() {
        deleteObj("users", currentUser).then(() => {
            notifier.send("User Deleted", "success");
            LoadUsers()
            NewUser();
        })
    }

    async function NewUser () {
        currentUser = await getObj("users")
        currentUser.pwd = '';
    }

    async function GetUser(id) {
        if (currentUser.id == id) return

        currentUser.pwd = "";
        currentUser = await getObj("users", id);
    }

    async function LoadUsers() {
        users = await getObjects("users");
    }

    onMount(async ()=> {
        LoadUsers()
        await NewUser()
        console.log("loadeed")
    })
</script>

<!-- Wait for currentUser to populate-->
{#await users}
<Loader />
{:then}
<div class="columns">
    <aside class="menu column is-2">
        <p class="menu-label">
            Current Users
        </p>
        <ul class="menu-list">
            <li>
                <ul>
                    {#each users as user}
                        <li><a href="#/auth/users/{user.id}">{user.name}</a></li>
                    {/each}
                </ul>
                <span class="pointer" on:click={ NewUser }>Add New User</span>
            </li>
        </ul>
    </aside>

    <div class="column">
        {#await currentUser}
        Loading...
        {:then}
        <span class="title">{#if currentUser.id}Edit{:else}Add{/if} User</span>
        <hr>
        <Form fields={fields} bind:data={currentUser} on:submit={SaveUser} on:delete={DeleteUser} {errors} />
        {/await}
    </div>
</div>
{/await}